import React from 'react';

import { MailingAddressForm } from '../../Form/Forms';

export default () => (
  <MailingAddressForm />
);
